import React, { useState, useRef, useEffect } from 'react';
import './Collapsible.scss';
import arrowDown from 'assets/images/icons/arrow.svg';
import editIcon from 'assets/images/icons/edit.svg';
import trashIcon from 'assets/images/icons/trashcan.svg';

interface CollapsibleProps {
    title: string | React.ReactNode;
    children: React.ReactNode;
    isInside?: boolean;
    isOpen?: boolean;
    className?: string;
    onToggle?: (isOpen: boolean) => void;
    showActions?: boolean;
    onEdit?: () => void;
    onDelete?: () => void;
    canEdit?: boolean;
    canDelete?: boolean;
}

export const Collapsible: React.FC<CollapsibleProps> = ({
    title,
    children,
    isOpen = false,
    className = '',
    onToggle,
    isInside = false,
    showActions = false,
    onEdit,
    onDelete,
    canEdit = true,
    canDelete = true
}) => {
    const [isCollapsed, setIsCollapsed] = useState(!isOpen);
    const [contentHeight, setContentHeight] = useState<number | undefined>(isOpen ? undefined : 0);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isCollapsed) {
            setContentHeight(contentRef.current?.scrollHeight);
        } else {
            setContentHeight(0);
        }
    }, [isCollapsed]);

    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
        onToggle?.(!isCollapsed);
    };

    const handleAction = (e: React.MouseEvent, callback?: () => void) => {
        e.stopPropagation(); // Empêche le toggle du collapsible
        callback?.();
    };

    return (
        <div className={`collapsible ${className} ${isCollapsed ? 'collapsed' : ''} ${isInside ? 'inside' : ''}`}>
            <div className="collapsible-header" onClick={handleToggle}>
                <div className="collapsible-title">{title}</div>
                <div className="collapsible-right">
                    {showActions && (
                        <div className="collapsible-actions">
                            {canEdit && (
                                <img src={editIcon} alt="edit" className="action-icon edit" onClick={(e) => handleAction(e, onEdit)} />
                            )}
                            {canDelete && (
                                <img
                                    src={trashIcon}
                                    alt="delete"
                                    className="action-icon delete"
                                    onClick={(e) => handleAction(e, onDelete)}
                                />
                            )}
                        </div>
                    )}
                    <img src={arrowDown} alt="toggle" className={`collapsible-icon ${isCollapsed ? '' : 'rotated'}`} />
                </div>
            </div>
            <div className="collapsible-content" style={{ height: contentHeight === undefined ? 'auto' : `${contentHeight}px` }}>
                <div ref={contentRef}>{children}</div>
            </div>
        </div>
    );
};
